import { render, staticRenderFns } from "./CreateModalForm.vue?vue&type=template&id=02af3ab9"
import script from "./CreateModalForm.vue?vue&type=script&lang=js"
export * from "./CreateModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports